export const HEATMAP_DAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] as const;
export const HEATMAP_BLOCK_LABELS = ['12a', '3a', '6a', '9a', '12p', '3p', '6p', '9p'] as const;
export const HEATMAP_BLOCKS = HEATMAP_BLOCK_LABELS.length;
export const HEATMAP_BLOCK_HOURS = 3;
